	import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
	import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
	import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { defaultMST3040_R01Filter, useMST3040_R01Store } from "./Store_MST3040_R01";
import { ChangeEvent, useCallback } from "react";
	import useUiuxStore from "src/store/useUiuxStore";
	import { getItemPopupList } from "src/apis/itemApi";
	import { ItemDto } from "src/types/base";
	import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { getBomParentItemList } from "src/apis/bomApi";
import { BomParentModalDto } from "src/dtos/bom/BomDto";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { blueButtonClass, grayButtonClass } from "src/components/common/common";



	export const SearchSection_MST3040_R01 = () => {

	const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
	const { MST3040_R01Filter, setMST3040_R01Filter, setModalVisible } = useMST3040_R01Store();

	const { setCodeSearchModalProps } = useUiuxStore();

	const prntItemcdHandleFoucsId = 'prntItemcd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'prntItemcd',
			category: 'BOM_모품목',
			focusId: prntItemcdHandleFoucsId,
			responseMapping: {
				prntItemcd: 'prntItemcd',
				itemNm: 'prntItemnm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getBomParentItemList(searchText);
				return itemResponse.data.data.find(value => value.prntItemcd === searchText);
			},
			extraFilter: () => ({
				prntItemcd: MST3040_R01Filter.prntItemcd || '',
				prntItemnm: MST3040_R01Filter.prntItemnm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST3040_R01Filter,
		setEditData: setMST3040_R01Filter,
		defaultData: defaultMST3040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST3040_R01_search'
	});

	const buttonClassName = (isDisabled?: boolean) => 
		`h-[24px] text-white rounded-[4px] px-[16px] font-semibold ${
			isDisabled 
				? grayButtonClass
				: blueButtonClass
		}`;

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="브랜드"
				value={MST3040_R01Filter.brandCd}
				optionList={brandCdList}
				// onChangeItem prop 사용, setBrandCd는 SysCodeDto를 받음
				onChangeItem={(selectedItem) => setMST3040_R01Filter({ brandCd: selectedItem?.minorCd || ''})}	
			/>
			<SearchDropDownForm
				label="품목그룹"
				value={MST3040_R01Filter.itemGroup}
				optionList={itemGroupList}
				onChangeItem={(selectedItem) => setMST3040_R01Filter({ itemGroup: selectedItem?.minorCd || ''})}
			/>
			<SearchCodeModalForm
				label="모품목코드"
				value={MST3040_R01Filter.prntItemcd}
				valueLabel={MST3040_R01Filter.prntItemnm}
				handleFoucsId={prntItemcdHandleFoucsId}
				onChange={getFieldHandlers('prntItemcd').onChange}
				onDoubleClick={getFieldHandlers('prntItemcd').onDoubleClick}
				onKeyDown={getFieldHandlers('prntItemcd').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[400px] min-w-[400px] mr-[10px]",
					titleStyle: "!w-[60px] !min-w-[60px] text-left ",
					codeInputStyle: "w-[120px] min-w-[120px]",
					nameTagStyle: "w-[190px] min-w-[190px] text-left",
				}}
			/>
			<button 
				className={buttonClassName(false)}
				onClick={() => {
					setModalVisible(true);
				}}
				disabled={false}>
				BOM 소요량 대조
			</button>

		</SearchSectionForm>
	)
	}